<template>
    <div class="toolbar-section" :class="{ current: isMobileNavSectionActive }" id="mobileMenu">
        <!-- Slideable (Mobile) Menu-->
        <nav class="slideable-menu mt-4">
            <ul class="menu">
                <li :class="{active: $route.name === 'home'}">
                    <span>
                        <router-link @click.native="hideSideBar" to='/'>
                            <span>{{$t("header.mobileNav.home")}}</span>
                        </router-link>
                    </span>
                </li>
                <li :class="{ active: inSelfPublishingFlow($route.name) }">
                    <span>
                        <router-link @click.native="hideSideBar" to='/self-publishing'>
                            <span>{{$t('PrintBookHeader.printMyBook')}}</span>
                        </router-link>
                    </span>
                </li>
                <li :class="{ active: $route.name === 'selfPublishingBooks' }">
                    <span>
                        <router-link @click.native="hideSideBar" to='/self-publishing/books'>
                            <span>{{$t('PrintBookHeader.myLibrary')}}</span>
                        </router-link>
                    </span>
                </li>
                <li v-if="isUserLogged" :class="{active: inProfileSection}">
                    <span>
                        <router-link @click.native="hideSideBar" to='/profile'>
                            <span>{{$t("header.mobileNav.profile")}}</span>
                        </router-link>
                    </span>
                </li>
                <li v-if="isUserLogged && user.isAdmin" :class="{ active: inAdministrationSection }">
                    <router-link @click.native="hideSideBar" to="/administration">
                        <span>{{$t('header.mainNav.administration')}}</span>
                    </router-link>
                </li>
                <li :class="{active: this.inHelpSection}">
                    <span>
                        <router-link @click.native="hideSideBar" to='/help'>
                            <span>{{$t("header.mobileNav.help")}}</span>
                        </router-link>
                    </span>
                </li>
                <li :class="{active: $route.name === 'contact'}">
                    <span>
                        <router-link @click.native="hideSideBar" to='/contact'>
                            <span>{{$t("header.mobileNav.contact")}}</span>
                        </router-link>
                    </span>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { inHelpSection, inProfileSection, inAdministrationSection, inSelfPublishingFlow } from "@/helpers/section";

export default {
    name: "PrintBookMobileNav",
    computed: {
        ...mapGetters("publishers", {
            publishers: "publishers",
        }),
        ...mapGetters("sideBarMenu", [
            "isMobileNavSectionActive",
        ]),
        ...mapGetters("config", {
            hermesAPIConfig: "hermesAPI",
        }),
        ...mapGetters("user", {
            isUserLogged: "isLogged",
            user: "user",
        }),
        inHelpSection() {
            return inHelpSection(this.$route.name);
        },
        inProfileSection() {
            return inProfileSection(this.$route.name);
        },
        inAdministrationSection() {
            return inAdministrationSection(this.$route.name);
        },
    },
    methods: {
        ...mapActions("sideBarMenu", {
            hideSideBar: "hide",
        }),
        inSelfPublishingFlow,
    },
};
</script>

<style scoped>

</style>